import PropTypes from 'prop-types';
import React, { useCallback, useContext, useState } from 'react';

import { ValidatedSingleLanguageInput } from '@bingads-webui-campaign-react/single-language-input';
import { I18nContext } from '@bingads-webui-react/i18n-context';

import { LanguageInfoBanner } from './language-info-banner';
import { LINKEDIN_SUPPORTED_TARGETING_LANGUAGES } from '../consts';

export const TargetingLanguage = ({ isDisabled }) => {
  const i18n = useContext(I18nContext);

  const [isEnglishSelected, setIsEnglishSelected] = useState(false);

  const onValidate = useCallback(({ data }) => {
    const { language } = data;
    setIsEnglishSelected(language === 'English');
  }, []);

  return (
    <div className="language-targeting">
      <ValidatedSingleLanguageInput
        i18n={i18n}
        label={i18n.getString(_TL_('What language do your potential customers speak?'))}
        languages={LINKEDIN_SUPPORTED_TARGETING_LANGUAGES}
        validationProps={{ field: 'language', onValidate }}
        disabled={isDisabled}
      />
      {isEnglishSelected && <LanguageInfoBanner />}
    </div>
  );
};

TargetingLanguage.propTypes = {
  isDisabled: PropTypes.bool.isRequired,
};
